import { http } from '../request'
import type { PaginationData } from '../request'
import type {
    OperatorSkin,
    OperatorSkinCreateRequest,
    OperatorSkinUpdateRequest,
    OperatorSkinCreateResponse,
    OperatorSkinUpdateResponse
} from '../types/operatorSkins'

/**
 * 干员皮相关 API
 */
export const operatorSkinsApi = {
    /**
     * 获取所有干员皮数据（分页格式）
     * GET /api/operator-skins/
     */
    getAllOperatorSkins(params?: { page?: number; size?: number }): Promise<PaginationData<OperatorSkin>> {
        return http.get<PaginationData<OperatorSkin>>('/api/operator-skins/', { params })
    },

    /**
     * 创建干员皮
     * POST /api/operator-skins/
     */
    createOperatorSkin(data: OperatorSkinCreateRequest): Promise<OperatorSkinCreateResponse> {
        return http.post<OperatorSkinCreateResponse>('/api/operator-skins/', data)
    },

    /**
     * 更新干员皮
     * PUT /api/operator-skins/{id}/
     */
    updateOperatorSkin(id: number, data: OperatorSkinUpdateRequest): Promise<OperatorSkinUpdateResponse> {
        return http.put<OperatorSkinUpdateResponse>(`/api/operator-skins/${id}/`, data)
    },

    /**
     * 删除干员皮
     * DELETE /api/operator-skins/{id}/
     */
    deleteOperatorSkin(id: number): Promise<void> {
        return http.delete<void>(`/api/operator-skins/${id}/`)
    }
}

export default operatorSkinsApi
